"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueueAction = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _AsyncAction2 = require("./AsyncAction");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var QueueAction =
/*#__PURE__*/
function (_AsyncAction) {
  (0, _inherits2.default)(QueueAction, _AsyncAction);

  function QueueAction(scheduler, work) {
    var _this;

    (0, _classCallCheck2.default)(this, QueueAction);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(QueueAction).call(this, scheduler, work));
    _this.scheduler = scheduler;
    _this.work = work;
    return _this;
  }

  (0, _createClass2.default)(QueueAction, [{
    key: "schedule",
    value: function schedule(state) {
      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (delay > 0) {
        return (0, _get2.default)((0, _getPrototypeOf2.default)(QueueAction.prototype), "schedule", this).call(this, state, delay);
      }

      this.delay = delay;
      this.state = state;
      this.scheduler.flush(this);
      return this;
    }
  }, {
    key: "execute",
    value: function execute(state, delay) {
      return delay > 0 || this.closed ? (0, _get2.default)((0, _getPrototypeOf2.default)(QueueAction.prototype), "execute", this).call(this, state, delay) : this._execute(state, delay);
    }
  }, {
    key: "requestAsyncId",
    value: function requestAsyncId(scheduler, id) {
      var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      // If delay exists and is greater than 0, or if the delay is null (the
      // action wasn't rescheduled) but was originally scheduled as an async
      // action, then recycle as an async action.
      if (delay !== null && delay > 0 || delay === null && this.delay > 0) {
        return (0, _get2.default)((0, _getPrototypeOf2.default)(QueueAction.prototype), "requestAsyncId", this).call(this, scheduler, id, delay);
      } // Otherwise flush the scheduler starting with this action.


      return scheduler.flush(this);
    }
  }]);
  return QueueAction;
}(_AsyncAction2.AsyncAction);

exports.QueueAction = QueueAction;